import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, } from 'antd';
import moment from 'moment';
import { dataDefault } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";
import compute from "./compute";
import Table6_2_2 from "./6.2.2";
import "./index.scss";
import getJson from '../../../../method/getJson';
import { sum } from '../../../../method';

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

const totalIndex = [0, 3, 14, 25, 46, 47];

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false,
            isUpdate: false,
            data5_1_1: []
        }
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data) => {
        data = compute([...data], this.state.date);

        data[47].total = (data[46].total - sum([
            getJson([2, 'REV'], this.state.data5_1_1),
            getJson([14, 'REV'], this.state.data5_1_1)
        ])).toFixed(2);

        this.setState({
            data,
        });
    }

    onChangeUpdate = (data) => {
        this.setState({ isUpdate: data });
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    // 获取表格5_6_1内容
    getData = (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);
        fetch(`/_6_2_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.now && x.data.now.length > 0) {
                data = x.data.now.sort((a, b) => {
                    return a.sort - b.sort
                });
                // 数据结构多次变化， 无法兼容，此表从头开始
                // if (data.length === 18) {
                //     data.push({
                //         name: "Total<br/>总计",
                //         meet: 0,
                //         space: 0,
                //         no: 0,
                //         sold: 0,
                //         occ: 0,
                //         total: 0,
                //         sc: 0,
                //         rev: 0,
                //         sort: 18,
                //     });
                // }
            }
            data.forEach((item, i) => {
                if (!totalIndex.includes(i)) {
                    data[i].meet = getJson([index, 'conference_num'], x.data.b17_1 || []);
                }
            });

            this.setState({ loading: false, data5_1_1: x.data.data5_1_1 || [] }, () => {
                this.computeNum(data);
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }
    // 保存表格5-6-1内容
    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_6_2', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                this.setState({ isUpdate: true });
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }


    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table6_2', 1.5, '6.21', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })
        });
    }

    onFillLastMonth = () => {
        if (this.state.data[0] && this.state.data[0].id) {
            message.error('当前月份数据已存在!')
            this.setState({ loading: false });
            return
        }
        this.setState({ loading: true, data: [] });
        const date = this.state.date;
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);
        fetch(`/_6_2_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.last && x.data.last.length > 0 && (x.data.now || []).length <= 0) {
                data = x.data.last.map(v => {
                    delete v.id;
                    delete v.month;
                    delete v.year;
                    return v
                }).sort((a, b) => {
                    return a.sort - b.sort
                });;
            };
            message.info('数据填充成功！');
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    render() {
        const { isUpdate, data } = this.state;

        const columns = [{
            title: <div>Meeting Room/Ballroom <br /> 会议室/宴会厅</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: "left",
            width: 300,
            render: (text, record, index) => {

                const props = {
                    text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex
                };

                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }

                return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                    <TableText data={{ ...props, }} />
                </div>
            }
        }, {
            title: <div>Meeting/Banquet Space SQM <br /> 场地面积（平方米）</div>,
            dataIndex: 'meet',
            key: 'meet',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "meet", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['Meeting/Banquet Space SQM <br /> 场地面积（平方米）'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Space Available SQM<br /> 可售总面积（平方米）</div>,
            dataIndex: 'space',
            key: 'space',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "space", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['Space Available SQM<br /> 可售总面积（平方米）'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>No. of Meeting/Events <br /> 会议场次</div>,
            dataIndex: 'no',
            key: 'no',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "no", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['No. of Meeting/Events <br /> 会议场次'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };

                let type = "number";
                if (!totalIndex.includes(index)) {
                    type = 'inputNumber'
                }
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }
                return <TableText data={{ ...props, type }} />
            }
        }, {
            title: <div>Sold Space<br /> 出售总面积（平方米）</div>,
            dataIndex: 'sold',
            key: 'sold',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "sold", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['Sold Space<br /> 出售总面积（平方米）'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };

                let type = "number";
                if (!totalIndex.includes(index)) {
                    type = 'inputNumber'
                }
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }
                return <TableText data={{ ...props, type }} />
            }
        }, {
            title: <div>Space Occupancy<br /> 会议场地出租率</div>,
            dataIndex: 'occ',
            key: 'occ',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "occ", type: "percent", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['Space Occupancy<br /> 会议场地出租率'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: <div>Total Catering Revenue<br /> 宴会活动总收入</div>,
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "total", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['Total Catering Revenue<br /> 宴会活动总收入'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };

                let type = "number";
                if (!totalIndex.includes(index)) {
                    type = 'inputNumber'
                }

                return <TableText data={{ ...props, type }} />
            }
        }, {
            title: <div>S/C<br /> 每平方米平均消费</div>,
            dataIndex: 'sc',
            key: 'sc',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "sc", type: "number", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['S/C<br /> 每平方米平均消费'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }
                return <TableText data={{ ...props, }} />
            }
        }, {
            title: <div>RevPASP <br /> 可售场地面积平均收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, name: "rev", type: "number", onChange: this.onChange, totalIndex,
                    compared: {
                        title: ['RevPASP <br /> 可售场地面积平均收入'],
                        record,
                        sqlName: "_6_2_new"
                    }
                };
                if (index === 47) {
                    return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                        <TableText data={{ ...props, type: '' }} />
                    </div>
                }
                return <TableText data={{ ...props, }} />
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 height-52">
                    <Row className="first-title">
                        6.2 F&B Catering/Banquet KPI Analysis 餐饮部宴会活动关键绩效指数分析
                    </Row>
                    <Row className="title" id="table6_2" style={{ width: this.state.print ? 1950 : 'auto' }}  >
                        <Row>6.2.1 MTD This Year 月累计 - 本年当月</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getData(str)
                                }}
                            />

                            {/* <Button
                                type="primary"
                                style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                onClick={this.onFillLastMonth}
                            >填充上月数据</Button> */}
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            scroll={this.state.print ? {} : { x: 1900, y: 500 }}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_6_2">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>
                </div>

                <Table6_2_2
                    update={isUpdate}
                    onChange={this.onChangeUpdate}
                />
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-2/index.js